import default_image from '@/assets/imagePlaceholder.jpeg';
import SidebarLink from '@/components/shared/Sidebar/SidebarLink';
import { basicLinkStyles } from '@/components/shared/Sidebar/styles';
import Scrollbars from '@/components/shared/SimpleBarScrollbar';
import { ApiProvider } from '@/provider/ApiProvider';
import { commentTagsRequired } from '@/utils/userRole';
import * as ConstantMessage from '@/provider/constantmessage';
import validations from '@/utils/validations';
import {
  Clear as ClearIcon,
  Close as CloseIcon,
  CloudUpload as CloudUploadIcon,
  Comment as CommentIcon,
  Edit as EditIcon,
  FilterAlt as FilterAltIcon,
  History as HistoryIcon,
  ThumbDown as ThumbDownIcon,
  ThumbUpOutlined as ThumbUpOutlinedIcon,
} from '@mui/icons-material';
import {
  Autocomplete,
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogTitle,
  Grid,
  Box,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Slide,
  TextField,
  TextareaAutosize,
  Tooltip,
  Typography,
} from '@mui/material';
import serialize from 'form-serialize';
import React, { forwardRef, useState } from 'react';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction='left' ref={ref} {...props} />;
});

export default function AlertDialogSlide({
  index,
  comment_module_type,
  comment_page,
  tiles_type,
  tab_type,
  page_brand_id,
  page_property_id,
  property_id,
  brand_id,
  isSidebarLink = false,
  displayTextSeeAll,
  displayAddCommentButton,
  onAddComments,
}) {
  const [open, setOpen] = useState(false);
  const [visibilityAddComment, setvisibilityAddComment] = useState(false);
  const [visibilityPropertySelect, setvisibilityPropertySelect] = useState(false);
  const [visibilityBrandSelect, setvisibilityBrandSelect] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [TagList, setTagList] = useState([]);
  const [BrandList, setBrandList] = useState([]);
  const [PropertyList, setPropertyList] = useState([]);
  const [keyword_tag, setkeyword_tag] = useState([]);
  const [TileList, setTileList] = useState([]);
  const [errors, Seterrors] = useState({});
  const [update_comment_id, Setupdate_comment_id] = useState('');
  const [tags, Settags] = useState([]);
  const [tiles, Settiles] = useState([]);
  const [media_upload_array, Setmedia_upload_array] = useState([]);
  const [properties_id, Setproperties_id] = useState([]);
  const [comment_brand_id, Setcomment_brand_id] = useState('');
  const [comments, setComments] = useState([]);
  const [commentsVisibility, setCommentsVisibility] = useState(false);
  const [visibilityCommentHistory, setvisibilityCommentHistory] = useState(false);
  const [HistoryList, setHistoryList] = useState([]);
  const [visibilityPropertySelectEdit, setvisibilityPropertySelectEdit] = useState(false);
  const [visibilityBrandSelectEdit, setvisibilityBrandSelectEdit] = useState(false);
  const [tag_arr, settag_arr] = useState([]);
  const [tiles_tag, settiles_tag] = useState([]);
  const [property_arr_set, setproperty_arr_set] = useState([]);
  const [brand_arr_set, setbrand_arr_set] = useState([]);
  const [filterBrand, SetFilterBrand] = useState([]);
  const [filterProperty, SetFilterProperty] = useState([]);
  const [filterTile, SetFilterTile] = useState([]);
  const [filterTags, SetFilterTags] = useState([]);
  const [VisibilityFilterProperty, setVisibilityFilterProperty] = useState(false);
  const [VisibilityFilterBrand, setVisibilityFilterBrand] = useState(false);
  const [VisibilityFilterComment, setVisibilityFilterComment] = useState(false);
  const [filterClass, setfilterClass] = useState(6);
  const [filter_tag_value, set_filter_tag_value] = useState([]);
  const [filter_tile_value, set_filter_tile_value] = useState([]);
  const [filter_property_value, set_filter_property_value] = useState([]);
  const [filter_brand_value, set_filter_brand_value] = useState([]);
  const [loading, setLoading] = useState(true);

  const ModuleType = comment_module_type;
  const TilesType = tiles_type;
  const PageBrandId = page_brand_id;
  const PagePropertyId = page_property_id;

  //-----------open the model----------------
  const handleClickOpen = () => {
    GetAllComments();
    setOpen(true);
    TagListCall();
    BrandListCall();
    PropertyListCall('');
    setvisibilityBrandSelect(false);
    setvisibilityPropertySelect(false);
    Settags([]);
    Settags([]);
    settag_arr([]);
    Settiles([]);
    settiles_tag([]);
  };

  //------------close the model-----------
  const handleClose = () => {
    if (!!update_comment_id) {
      visibilityEditCommentCancel(update_comment_id);
      Setupdate_comment_id('');
      setOpen(false);
    } else {
      setOpen(false);
      setvisibilityAddComment(false);
      Settags([]);
      settag_arr([]);
      Settiles([]);
      settiles_tag([]);
      setvisibilityBrandSelect(false);
      setvisibilityPropertySelect(false);
    }
  };

  //------------api calling for tag list-------------------
  const TagListCall = () => {
    ApiProvider.webserviceGet('Comments/GetTags').then(
      (response) => {
        if (response.success == true) {
          setTagList(response.data.results);
        } else {
          setTagList([]);
        }
        TileListCall();
      },
      (error) => {
        setTagList([]);
        ApiProvider.globalToastMessage(error, 5000, 'error');
        return;
      },
    );
  };

  //----------api calling for tile list-------------------
  const TileListCall = () => {
    const sub_module_type = tab_type || '';

    ApiProvider.webserviceGet(
      'GetTiles?flag=active&module_type=' + comment_page + '&sub_module_type=' + sub_module_type,
    ).then(
      (response) => {
        if (response.success == true) {
          setTileList(response.data.results);
        } else {
          setTileList([]);
        }
      },
      (error) => {
        setTileList([]);
        ApiProvider.globalToastMessage(error, 5000, 'error');
        return;
      },
    );
  };

  //---------api calling for brand list--------------------
  const BrandListCall = () => {
    ApiProvider.webserviceGet('Brands/GetBrands').then(
      (response) => {
        if (response.success == true) {
          setBrandList(response.data.results);
        } else {
          setBrandList([]);
        }
      },
      (error) => {
        setBrandList([]);
        ApiProvider.globalToastMessage(error, 5000, 'error');
        return;
      },
    );
  };

  //---------api calling for property list--------------------
  const PropertyListCall = (value) => {
    let body = new FormData();
    body.append('flag', 'active');
    body.append('page', 1);
    body.append('term', value);
    ApiProvider.webservicePostToken('Property/GetPropertyList', body, 'yes').then(
      (response) => {
        if (response.success == true) {
          setPropertyList(response.data.results);
        } else {
          setPropertyList([]);
        }
      },
      (error) => {
        setPropertyList([]);
        ApiProvider.globalToastMessage(error, 5000, 'error');
        return;
      },
    );
  };

  //--------on change tag drop down---------------
  const TagChange = (event, value) => {
    if (value != null) {
      if (value.length > 0) {
        const arr = [];
        value.forEach((key_get) => {
          arr.push(key_get.id);
          if (key_get.id == 1 || key_get.id == 5) {
            setvisibilityPropertySelect(true);
            setvisibilityPropertySelectEdit(true);
          }
          if (key_get.id == 2 || key_get.id == 5) {
            setvisibilityBrandSelect(true);
            setvisibilityBrandSelectEdit(true);
          }
          Settags(JSON.stringify(arr));
          settag_arr(value);
          //--select swot--
          if (key_get.id == 7 || key_get.id == 8 || key_get.id == 9 || key_get.id == 10) {
            const index = TileList.findIndex((obj) => obj.name == 'SWOT');
            if (index >= 0) {
              const tiles_1 = tiles;
              const tiles_tag_1 = tiles_tag;
              if (tiles_1.indexOf(TileList[index].id) == -1) {
                tiles_1.push(TileList[index].id);
                tiles_tag_1.push(TileList[index]);
                Settiles(JSON.stringify(tiles_1));
                settiles_tag(tiles_tag_1);
              }
            }
          }
        });
      } else {
        setvisibilityBrandSelectEdit(false);
        setvisibilityPropertySelectEdit(false);
        setvisibilityBrandSelect(false);
        setvisibilityPropertySelect(false);
        Settags([]);
        settag_arr([]);
      }
    } else {
      setvisibilityBrandSelectEdit(false);
      setvisibilityPropertySelectEdit(false);
      setvisibilityBrandSelect(false);
      setvisibilityPropertySelect(false);
      Settags([]);
      settag_arr([]);
    }
  };

  //--------on change tiles drop down---------------
  const TileChange = (event, value) => {
    if (value != null) {
      if (value.length > 0) {
        const arr = [];
        value.forEach((key_get) => {
          arr.push(key_get.id);
        });

        Settiles(JSON.stringify(arr));
        settiles_tag(value);
      } else {
        Settiles([]);

        settiles_tag([]);
      }
    } else {
      Settiles([]);
      settiles_tag([]);
    }
  };

  //--------on change property drop down---------------
  const PropertyChange = (event, value) => {
    if (value != null) {
      Setproperties_id(value.id);
      setproperty_arr_set(value);
    } else {
      Setproperties_id([]);
      setproperty_arr_set(null);
    }
  };

  //--------on change brand drop down---------------
  const BrandListChange = (event, value) => {
    if (value != null) {
      Setcomment_brand_id(value.id);
      setbrand_arr_set(value);
    } else {
      Setcomment_brand_id('');
      setbrand_arr_set(null);
    }
  };

  //----------comment list----------
  const GetAllComments_1 = () => {
    let body = new FormData();
    if (PageBrandId != undefined && PageBrandId.length > 0) {
      body.append('brand_ids[]', PageBrandId);
      setVisibilityFilterBrand(true);
      setfilterClass(4);
    }

    if (TilesType) body.append(isNaN(TilesType) ? 'tile_types[]' : 'tile_ids[]', TilesType);
    if (ModuleType) body.append('module_type', ModuleType);

    if (PagePropertyId != undefined && PagePropertyId.length > 0) {
      body.append('property_ids[]', PagePropertyId);
      setVisibilityFilterProperty(true);
      setfilterClass(4);
    }

    setLoading(true);
    ApiProvider.webservicePostToken('Comments/GetComments', body, 'yes').then(
      (response) => {
        setLoading(false);
        setCommentsVisibility(response.success);

        if (response.success) {
          setComments(response.data.results);
        } else {
          setComments([]);
        }
      },
      (error) => {
        setLoading(false);
        setComments([]);
        ApiProvider.globalToastMessage(error, 5000, 'error');
        return;
      },
    );
  };

  const GetAllComments = () => {
    let body = new FormData();
    if (PageBrandId != undefined && PageBrandId.length > 0) {
      body.append('brand_ids[]', PageBrandId);
      setVisibilityFilterBrand(true);
      setfilterClass(4);
    }

    if (TilesType) body.append(isNaN(TilesType) ? 'tile_types[]' : 'tile_ids[]', TilesType);
    if (ModuleType) body.append('module_type', ModuleType);

    if (PagePropertyId != undefined && PagePropertyId.length > 0) {
      body.append('property_ids[]', PagePropertyId);
      setVisibilityFilterProperty(true);
      setfilterClass(4);
    }

    //------filter tiles----------------
    if (filterTile != undefined && filterTile.length > 0) {
      let filterTile_1 = JSON.parse(filterTile);
      filterTile_1.forEach((key_get) => {
        body.append(isNaN(key_get) ? 'tile_types[]' : 'tile_ids[]', key_get);
      });
    }
    //--------filter tag ------------------
    if (filterTags != undefined && filterTags.length > 0) {
      let filterTags_1 = JSON.parse(filterTags);
      filterTags_1.forEach((key_get) => {
        body.append('tag_ids[]', key_get);
      });
    }
    //--------property filter-------------
    if (filterProperty != undefined && filterProperty.length > 0) {
      let filterProperty_1 = JSON.parse(filterProperty);
      filterProperty_1.forEach((key_get) => {
        body.append('property_ids[]', key_get);
      });
    }
    //---------brand filter--------
    if (filterBrand != undefined && filterBrand.length > 0) {
      let filterBrand_1 = JSON.parse(filterBrand);
      filterBrand_1.forEach((key_get) => {
        body.append('brand_ids[]', key_get);
      });
    }

    setLoading(true);
    ApiProvider.webservicePostToken('Comments/GetComments', body, 'yes').then(
      (response) => {
        setLoading(false);
        setCommentsVisibility(response.success);

        if (response.success) {
          setComments(response.data.results);
        } else {
          setComments([]);
        }
      },
      (error) => {
        setLoading(false);
        setComments([]);
        ApiProvider.globalToastMessage(error, 5000, 'error');
        return;
      },
    );
  };

  //-----------edit change------------------
  const visibilityEditCommentCancel = (id) => {
    setvisibilityBrandSelectEdit(false);
    setvisibilityPropertySelectEdit(false);
    document.getElementById('comment_list_div' + id).style.display = 'block';
    document.getElementById('comment_edit_div' + id).style.display = 'none';
  };

  const handleCaptureMedia = (event) => {
    let file = event.target.files[0];
    if (event.target.files[0] != undefined) {
      const file_name = event.target.files[0].name;
      const extension = file_name.split('.').pop();
      const accepted_arr = [
        'pdf',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'jpg',
        'jpeg',
        'png',
        'gif',
        'svg',
      ];
      const accept_status = accepted_arr.filter((item) => item == extension);
      if (accept_status.length <= 0) {
        ApiProvider.globalToastMessage(
          ConstantMessage.error_file_accepted + accepted_arr.join(),
          5000,
          'error',
        );
        return false;
      }

      let body = new FormData();
      body.append('uploaded_file', file);
      body.append('folder_name', 'media');
      ApiProvider.webservicePostToken('Medias/UploadMedia', body, 'yes').then(
        (response) => {
          if (response.success == true) {
            const row = response.data[0];
            const extension = file_name.split('.').pop();
            row.file_name = file_name;
            row.extension = extension;
            const accepted_arr = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
            const accept_status = accepted_arr.filter((item) => item == extension);
            row.file_type = 'other';
            if (accept_status.length > 0) {
              row.file_type = 'image';
            }
            Setmedia_upload_array([row]);
          } else {
            ApiProvider.globalApiErrorMessage(response.message);
            return;
          }
        },
        (error) => {
          ApiProvider.globalToastMessage(error, 5000, 'error');
          return;
        },
      );
    }
  };

  const handleMediaDelete = () => {
    console.warn('Media Delete not implemented.');
  };

  const CommentLikeDislike = (comment_id, flag) => {
    ApiProvider.webserviceGet(
      'Comments/LikeDislike?comment_id=' + comment_id + '&type=' + flag + '',
    ).then(
      (response) => {
        if (response.success == true) {
          document.getElementById('comment_like_count' + comment_id).innerHTML =
            response.data.likes;
          document.getElementById('comment_dislike_count' + comment_id).innerHTML =
            response.data.dislikes;
        }
      },
      (error) => {
        ApiProvider.globalToastMessage(error, 5000, 'error');
        return;
      },
    );
  };

  const CommentHistory = (commentId) => {
    ApiProvider.webserviceGet('Comments/CommentHistory?comment_id=' + commentId).then(
      (response) => {
        if (response.success == true) {
          setCommentsVisibility(false);
          setvisibilityCommentHistory(true);
          setHistoryList(response.data.results);
        } else {
          setHistoryList([]);
        }
      },
      (error) => {
        setHistoryList([]);
        ApiProvider.globalToastMessage(error, 5000, 'error');
        return;
      },
    );
  };

  //--------hide history-----------
  const hideVisibilityCommentHistory = () => {
    setvisibilityCommentHistory(false);
    setCommentsVisibility(true);
  };

  //-----------add comments-------------------------
  const handleSubmit = () => {
    const form = document.querySelector('#addcomment');
    const obj = serialize(form, { hash: true });

    if (!validate(obj)) return;

    setSubmitted(true);
    let body = new FormData();
    body.append('comments', obj.comments);

    if (ModuleType) body.append('module_type', ModuleType);

    if (obj.tags != undefined) {
      let tags = JSON.parse(obj.tags);
      tags.forEach((key_get) => {
        body.append('tags[]', key_get);
        if (key_get == 1 || key_get == 5) {
          body.append('property_id', obj.properties_id);
        } else {
          if (PagePropertyId != undefined) body.append('property_id', PagePropertyId);
        }

        if (key_get == 2 || key_get == 5) {
          body.append('brand_id', obj.brand_id);
        } else {
          if (PageBrandId != undefined) body.append('brand_id', PageBrandId);
        }
      });
    } else {
      if (PageBrandId != undefined) body.append('brand_id', PageBrandId);
      if (PagePropertyId != undefined) body.append('property_id', PagePropertyId);
    }

    if (obj.tiles != undefined) {
      let tiles = JSON.parse(obj.tiles);
      tiles.forEach((key_get) => {
        body.append('tile_ids[]', key_get);
      });
    }

    if (media_upload_array.length > 0) {
      media_upload_array.forEach((value_get, key) => {
        body.append('document_file[' + key + '][file_s3_key]', value_get.file_s3_key);
        body.append('document_file[' + key + '][media_id]', value_get.media_id);
      });
    }

    ApiProvider.webservicePostToken('Comments/AddComment', body, 'yes').then(
      (response) => {
        if (response.success == true) {
          Setmedia_upload_array([]);
          Settags([]);
          setvisibilityAddComment(false);
          setvisibilityPropertySelect(false);
          setvisibilityBrandSelect(false);
          setSubmitted(false);
          ApiProvider.globalToastMessage(response.message, 5000, 'success');
          GetAllComments();
          if (onAddComments) {
            onAddComments();
          }
        } else {
          setSubmitted(false);
          ApiProvider.globalApiErrorMessage(response.message);
          return;
        }
      },
      (error) => {
        ApiProvider.globalToastMessage(error, 5000, 'error');
        return;
      },
    );
  };

  const handleToggleVisibilityAddComment = () => {
    setvisibilityAddComment(true);
    if (!TilesType) return;

    let index;

    if (isNaN(TilesType)) {
      // TilesType is a string — match by tiles_type
      index = TileList.findIndex((obj) => obj.tiles_type == TilesType);
    } else {
      // TilesType is a number — match by id
      index = TileList.findIndex((obj) => obj.id == TilesType);
    }
    if (index < 0) return;

    const tiles_1 = tiles;
    const tiles_tag_1 = tiles_tag;
    if (tiles_1.indexOf(TileList[index].id) !== -1) return;

    tiles_1.push(TileList[index].id);
    tiles_tag_1.push(TileList[index]);
    Settiles(JSON.stringify(tiles_1));
    settiles_tag(tiles_tag_1);
  };

  //----------update comment----------------------

  const EditTag = (id) => {
    Setupdate_comment_id(id);
    setvisibilityAddComment(false);
    const index = comments.findIndex((obj) => obj.id == id);
    if (index >= 0) {
      const comment_data = comments[index];
      const tagsArea = comment_data.tagsArea;
      const keywordTag = comment_data.keywordTag;
      const tiles = comment_data.tiles;
      if (tagsArea.length > 0) {
        const arr = [];
        const arr1 = [];
        let check_property = 'no';
        let check_brand = 'no';
        tagsArea.forEach((key_get) => {
          const id_get = key_get;
          const index = TagList.findIndex((obj) => obj.name == id_get);
          if (index >= 0) {
            const id = TagList[index].id;
            if (id == 1 || id == 5) {
              check_property = 'yes';
            }
            if (id == 2 || id == 5) {
              check_brand = 'yes';
            }

            arr1.push(id);
            arr.push(TagList[index]);
          }
          settag_arr(arr);
        });

        setTimeout(() => {
          if (check_property == 'yes') {
            setvisibilityPropertySelectEdit(true);
            Setproperties_id(comment_data.property_id);
            const propertyJson = {
              id: comment_data.property_data.id,
              full_name: comment_data.property_data.name,
            };
            setproperty_arr_set(propertyJson);
          } else {
            setvisibilityPropertySelectEdit(false);
          }

          if (check_brand == 'yes') {
            setvisibilityBrandSelectEdit(true);
            Setcomment_brand_id(comment_data.brand_id);
            setbrand_arr_set(comment_data.brand_data);
          } else {
            setvisibilityBrandSelectEdit(false);
          }
          Settags(JSON.stringify(arr1));
        }, 100);
      } else {
        setvisibilityPropertySelectEdit(false);
        setvisibilityBrandSelectEdit(false);
      }

      if (keywordTag.length > 0) {
        const arr = [];
        keywordTag.forEach((key_get) => {
          const json = {
            name: key_get,
          };
          arr.push(json);
        });
      }
      //------------------tiles---------------

      if (tiles.length > 0) {
        const arr = [];
        const arr1 = [];
        tiles.forEach((key_get) => {
          const id_get = key_get;
          const index = TileList.findIndex((obj) => obj.name == id_get);
          if (index >= 0) {
            arr1.push(TileList[index].id);
            arr.push(TileList[index]);
          }
        });
        settiles_tag(arr);
        Settiles(JSON.stringify(arr1));
      }

      const files = comment_data.files;
      if (files.length > 0) {
        const new_arr = [];
        files.forEach((key_get) => {
          const old_data = key_get;
          const extension = old_data.name.split('.').pop();
          old_data.extension = extension;
          const accepted_arr = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];
          const accept_status = accepted_arr.filter((item) => item == extension);

          let file_type_set = 'other';
          if (accept_status.length > 0) {
            file_type_set = 'image';
          }

          old_data.file_type = file_type_set;

          new_arr.push(old_data);
        });
      } else {
        Setmedia_upload_array(files);
      }
      document.getElementById('comment_list_div' + id).style.display = 'none';
      document.getElementById('comment_edit_div' + id).style.display = 'block';
    }
  };

  const handleToggleVisibilityCancel = () => {
    setvisibilityAddComment(false);
    Settags([]);
    settag_arr([]);
    Settiles([]);
    settiles_tag([]);
    setvisibilityBrandSelect(false);
    setvisibilityPropertySelect(false);
  };

  const DeleteTag = () => {
    const array = [...keyword_tag]; // make a separate copy of the array
    array.splice(index, 1);
    setkeyword_tag(array);
  };

  const handleUpdate = (comment_id) => {
    const form = document.querySelector('#editcomment' + comment_id);
    const obj = serialize(form, { hash: true });

    if (validate(obj)) {
      let body = new FormData();
      body.append('comments', obj.comments);
      body.append('comment_id', comment_id);

      if (ModuleType) body.append('module_type', ModuleType);

      if (obj.tags != undefined) {
        let tags = JSON.parse(obj.tags);
        tags.forEach((key_get) => {
          body.append('tags[]', key_get);
          if (key_get == 1 || key_get == 5) {
            if (
              obj.properties_id != null &&
              obj.properties_id != undefined &&
              obj.properties_id != ''
            ) {
              body.append('property_id', obj.properties_id);
            }
          } else {
            if (PagePropertyId != null && obj.PagePropertyId != undefined && PagePropertyId != '')
              body.append('property_id', PagePropertyId);
          }

          if (key_get == 2 || key_get == 5) {
            if (obj.brand_id != null && obj.brand_id != undefined && obj.brand_id != '') {
              body.append('brand_id', obj.brand_id);
            }
          } else {
            if (PageBrandId != null && PageBrandId != undefined && PageBrandId != '')
              body.append('brand_id', PageBrandId);
          }
        });
      } else {
        if (PageBrandId != undefined) body.append('brand_id', PageBrandId);
        if (PagePropertyId != undefined) body.append('property_id', PagePropertyId);
      }

      if (obj.tiles != undefined) {
        let tiles = JSON.parse(obj.tiles);
        tiles.forEach((key_get) => {
          body.append('tile_ids[]', key_get);
        });
      }

      if (media_upload_array.length > 0) {
        media_upload_array.forEach((value_get, key) => {
          body.append('document_file[' + key + '][file_s3_key]', value_get.file_s3_key);
          body.append('document_file[' + key + '][media_id]', value_get.media_id);
        });
      }

      ApiProvider.webservicePostToken('Comments/UpdateComment', body, 'yes').then(
        (response) => {
          if (response.success == true) {
            document.getElementById('comment_list_div' + comment_id).style.display = 'block';
            document.getElementById('comment_edit_div' + comment_id).style.display = 'none';
            Setmedia_upload_array([]);
            Settags([]);
            setvisibilityBrandSelectEdit(false);
            setvisibilityPropertySelectEdit(false);
            setvisibilityAddComment(false);
            setvisibilityPropertySelect(false);
            setvisibilityBrandSelect(false);
            setSubmitted(false);
            GetAllComments();
            if (onAddComments) {
              onAddComments();
            }
            ApiProvider.globalToastMessage(response.message, 5000, 'success');

            setSubmitted(false);
          } else {
            setSubmitted(false);
            ApiProvider.globalApiErrorMessage(response.message);
            return;
          }
        },
        (error) => {
          ApiProvider.globalToastMessage(error, 5000, 'error');
          return;
        },
      );
    }
  };

  const _handleKeyDown = () => {};

  //--------validation
  const validate = (obj) => {
    let errors = {};
    let isValid = true;
    if (!obj.comments) {
      isValid = false;
      errors['comments'] = ConstantMessage.error_comment;
    } else {
      if (!validations.validateAlphanumericMore(obj.comments)) {
        isValid = false;
        errors['comments'] = ConstantMessage.error_description_validation;
      } else if (obj.comments.length > 500) {
        isValid = false;
        errors['comments'] = ConstantMessage.error_description_length_validation;
      } else {
        errors['comments'] = '';
      }
    }

    // Internal contexts tag their comments (was: role id 11 in the stored `userRole` list).
    if (commentTagsRequired()) {
      if (!obj.keyword_tag && !obj.tags) {
        isValid = false;
        errors['tags'] = ConstantMessage.error_tag_select;
      }
    }

    if (obj.tags) {
      let tags = JSON.parse(obj.tags);
      let check_property = 'no';
      let check_brand = 'no';
      tags.forEach((key_get) => {
        if (key_get == 1 || key_get == 5) {
          check_property = 'yes';
        }
        if (key_get == 2 || key_get == 5) {
          check_brand = 'yes';
        }
      });

      if (check_property == 'yes' && property_id == undefined && obj.properties_id == undefined) {
        isValid = false;
        errors['properties_id'] = ConstantMessage.error_group_property_select;
      } else {
        errors['properties_id'] = '';
      }

      if (check_brand == 'yes' && brand_id == undefined && obj.brand_id == undefined) {
        isValid = false;
        errors['comment_brand_id'] = 'Please Select Brand';
      } else {
        errors['comment_brand_id'] = '';
      }
    }

    Seterrors(errors);
    return isValid;
  };

  //-----------------filter---------------------------
  //------tag change----------
  const filterTagChange = (event, value) => {
    if (value != null) {
      if (value.length > 0) {
        const arr = [];
        value.forEach((key_get) => {
          arr.push(key_get.id);
        });

        SetFilterTags(JSON.stringify(arr));
        set_filter_tag_value(value);
      } else {
        SetFilterTags([]);
        set_filter_tag_value([]);
      }
    } else {
      SetFilterTags([]);
      set_filter_tag_value([]);
    }
  };

  const filterTileChange = (event, value) => {
    if (value != null) {
      if (value.length > 0) {
        const arr = [];
        value.forEach((key_get) => {
          arr.push(key_get.id);
        });
        SetFilterTile(JSON.stringify(arr));
        set_filter_tile_value(value);
      } else {
        SetFilterTile([]);
        set_filter_tile_value([]);
      }
    } else {
      SetFilterTile([]);
      set_filter_tile_value([]);
    }
  };

  const filterPropertyChange = (event, value) => {
    if (value != null) {
      if (value.length > 0) {
        const arr = [];
        value.forEach((key_get) => {
          arr.push(key_get.id);
        });
        SetFilterProperty(JSON.stringify(arr));
        set_filter_property_value(value);
      } else {
        set_filter_property_value([]);
        SetFilterProperty([]);
      }
    } else {
      set_filter_property_value([]);
      SetFilterProperty([]);
    }
  };

  const filterBrandChange = (event, value) => {
    if (!value || !value.length) {
      set_filter_brand_value([]);
      SetFilterBrand([]);
    }

    const arr = value.map((key_get) => key_get.id);

    SetFilterBrand(JSON.stringify(arr));
    set_filter_brand_value(value);
  };

  const filterSearch = () => {
    GetAllComments();
  };

  const filterReset = () => {
    SetFilterBrand([]);
    SetFilterProperty([]);
    SetFilterTile([]);
    SetFilterTags([]);
    set_filter_tag_value([]);
    set_filter_tile_value([]);
    set_filter_brand_value([]);
    set_filter_property_value([]);
    setComments([]);
    setTimeout(() => {
      GetAllComments_1();
      setVisibilityFilterComment(false);
    }, 500);
  };

  const handleFilterOpen = () => {
    if (VisibilityFilterComment == true) {
      setVisibilityFilterComment(false);
    } else setVisibilityFilterComment(true);
  };

  return (
    <div>
      <Tooltip title={displayAddCommentButton ? '' : 'Comments'} placement='top' arrow>
        {isSidebarLink ? (
          <SidebarLink
            icon={CommentIcon}
            text='Comments'
            boxContainerStyles={basicLinkStyles}
            handleClick={handleClickOpen}
          />
        ) : displayAddCommentButton ? (
          <React.Fragment>
            {ApiProvider.permission('comments_create') && (
              <Box className='flex_center' mb={1} mt={1}>
                <Button
                  variant='outlined'
                  aria-label='comment'
                  color='primary'
                  onClick={handleClickOpen}
                >
                  Add Comment
                </Button>
              </Box>
            )}
          </React.Fragment>
        ) : (
          <Button
            size='small'
            aria-label='comment'
            className='primary_color icon_default'
            onClick={handleClickOpen}
          >
            {displayTextSeeAll ? (
              <Typography variant='caption' sx={{ cursor: 'pointer' }}>
                See all
              </Typography>
            ) : (
              <CommentIcon />
            )}
          </Button>
        )}
      </Tooltip>

      {/* Comment dialog. */}
      <Dialog
        className='nu-com-model2 modal_lg comment_right_modal2'
        open={open}
        hideBackdrop
        disableScrollLock
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby='alert-dialog-slide-title'
        aria-describedby='alert-dialog-slide-description'
      >
        <div className='close_commentbox' onClick={handleClose}>
          <CloseIcon color='secondary' />
        </div>

        <DialogTitle className='comment_tfontsize' id='alert-dialog-slide-title'>
          Comments
        </DialogTitle>
        <div className='open_filterbox' onClick={handleFilterOpen}>
          <Tooltip
            title='Change filter settings for comments in this panel.'
            placement='right'
            arrow
          >
            <FilterAltIcon />
          </Tooltip>
        </div>

        <div className='comment_outer_spacing'>
          {VisibilityFilterComment && (
            <div className='comment_filter'>
              <Grid item container spacing={2}>
                <Grid item size={{ lg: filterClass }}>
                  <Autocomplete
                    multiple
                    id='tags'
                    className='full-width margin_b'
                    value={filter_tag_value}
                    onChange={(event, value) => filterTagChange(event, value)}
                    options={TagList ? TagList : []}
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        onKeyDown={_handleKeyDown}
                        label='Tags'
                        variant='outlined'
                      />
                    )}
                  />
                </Grid>
                <Grid item size={{ lg: filterClass }}>
                  <Autocomplete
                    multiple
                    id='tiles'
                    className='full-width margin_b'
                    value={filter_tile_value}
                    onChange={(event, value) => filterTileChange(event, value)}
                    options={TileList ? TileList : []}
                    getOptionLabel={(option) => option.name}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        onKeyDown={_handleKeyDown}
                        label='Tiles'
                        variant='outlined'
                      />
                    )}
                  />
                </Grid>
                {VisibilityFilterProperty && (
                  <Grid item size={{ lg: 4 }}>
                    <Autocomplete
                      multiple
                      id='property12'
                      className='full-width margin_b'
                      value={filter_property_value}
                      onChange={(event, value) => filterPropertyChange(event, value)}
                      options={PropertyList ? PropertyList : []}
                      getOptionLabel={(option) => option.full_name}
                      renderInput={(params) => (
                        <TextField {...params} label='Right Holder/Partner' variant='outlined' />
                      )}
                    />
                  </Grid>
                )}

                {VisibilityFilterBrand && (
                  <Grid item size={{ lg: 4 }}>
                    <Autocomplete
                      multiple
                      id='brand12'
                      className='full-width margin_b'
                      value={filter_brand_value}
                      onChange={(event, value) => filterBrandChange(event, value)}
                      options={BrandList ? BrandList : []}
                      getOptionLabel={(option) => option.name}
                      renderInput={(params) => (
                        <TextField {...params} label='Brand' variant='outlined' />
                      )}
                    />
                  </Grid>
                )}
              </Grid>
              <div className='text_right margin_b'>
                <Button variant='contained' className='margin_right' onClick={filterReset}>
                  Reset
                </Button>
                <Button variant='contained' color='secondary' onClick={filterSearch}>
                  Search
                </Button>
              </div>
            </div>
          )}

          <Scrollbars style={{ marginTop: '0', height: 'calc(100vh - 120px)' }} id='comment_list'>
            <List>
              {loading ? (
                <div
                  style={{
                    gap: 16,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <CircularProgress size={20} />
                  <Typography>Loading comments...</Typography>
                </div>
              ) : !comments.length ? (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Typography> There are no comments for this section. Add the first!</Typography>
                </div>
              ) : null}

              {commentsVisibility &&
                comments.map((data, key) => (
                  <div key={key} className='comment_card box_shadow nopadding relative_div'>
                    <div id={`comment_list_div${data.id}`} className='comment_list_div'>
                      <ListItem alignItems='flex-start'>
                        {Boolean(ApiProvider.permission('comments_edit')) &&
                          Boolean(data.user_id == ApiProvider.returnUserData()?.id) && (
                            <div className='cedit'>
                              <EditIcon onClick={() => EditTag(data.id)} />
                            </div>
                          )}

                        <ListItemText
                          className='comment_content comment_username'
                          primary={data.name}
                          secondary={data.comments}
                        />
                      </ListItem>

                      {data.files.map((data_get, key) => (
                        <div key={key} className='comment_share_section'>
                          <a
                            href={data_get.file_path}
                            target='_blank'
                            style={{
                              color: '#3678a8',
                              textDecoration: 'underline',
                              cursor: 'pointer',
                            }}
                            rel='noreferrer'
                          >
                            {data_get.name}
                          </a>
                        </div>
                      ))}

                      <ListItem
                        alignItems='flex-start'
                        style={{ display: 'block', paddingRight: '0px' }}
                      >
                        <Scrollbars style={{ width: 620, height: 70, overflowY: 'hidden' }}>
                          {data.tagsArea.map((tag_name, key) => (
                            <Chip
                              key={key}
                              className='font_small'
                              label={tag_name}
                              style={{ margin: '3px' }}
                            />
                          ))}

                          {data.keywordTag.map((tag_new_name, key) => (
                            <Chip
                              key={key}
                              className='font_small'
                              label={tag_new_name}
                              style={{ margin: '3px' }}
                            />
                          ))}

                          {data.tiles.map((tiles_name, key) => (
                            <Chip
                              key={key}
                              className='font_small'
                              label={tiles_name}
                              style={{ margin: '3px' }}
                            />
                          ))}

                          {Boolean(Object.keys(data.property_data).length > 0) && (
                            <Chip
                              className='font_small'
                              label={data.property_data.name}
                              style={{ margin: '3px' }}
                            />
                          )}

                          {Boolean(Object.keys(data.brand_data).length > 0) && (
                            <Chip
                              className='font_small'
                              label={data.brand_data.name}
                              style={{ margin: '3px' }}
                            />
                          )}
                        </Scrollbars>
                      </ListItem>

                      <div className='comment_share_section flex margin_top3'>
                        <Typography
                          className='comment_date'
                          variant='caption'
                          color='textSecondary'
                          component='div'
                        >
                          {data.date}
                        </Typography>
                        <div className='text_right comment_icon'>
                          <div className='font_small'>
                            <ThumbUpOutlinedIcon
                              fontSize='small'
                              onClick={() => CommentLikeDislike(data.id, 'like')}
                            />
                            <div id={`comment_like_count${data.id}`}>{data.totalLikes}</div>
                          </div>
                          <div className='font_small'>
                            <ThumbDownIcon
                              fontSize='small'
                              onClick={() => CommentLikeDislike(data.id, 'dislike')}
                            />
                            <div id={`comment_dislike_count${data.id}`}>{data.totalDisLikes}</div>
                          </div>
                          <div className='font_small'>
                            <HistoryIcon fontSize='small' onClick={() => CommentHistory(data.id)} />
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* edit comment */}
                    <div
                      className='edit_form comment_edit_div'
                      style={{ display: 'none' }}
                      id={`comment_edit_div${data.id}`}
                    >
                      <form
                        id={`editcomment${data.id}`}
                        encType='multipart/form-data'
                        autoComplete='off'
                      >
                        <div className='comment_card box_shadow nopadding relative_div'>
                          <ListItem alignItems='flex-start' style={{ flexWrap: 'wrap' }}>
                            <Grid container item spacing={1}>
                              <Grid item size={12}>
                                <TextareaAutosize
                                  style={{
                                    width: '88%',
                                    background: 'transparent',
                                    marginTop: '0.5rem',
                                  }}
                                  name='comments'
                                  className='custom_textarea'
                                  aria-label='minimum height'
                                  defaultValue={data.comments}
                                  minRows={2}
                                  placeholder='Comments *'
                                />
                                <input type='text' name='comment_id' value={data.id} hidden />
                                <div className='invalid-feedback'>{errors.comments}</div>
                              </Grid>
                              <Grid item size={12}>
                                <Autocomplete
                                  multiple
                                  id='tags'
                                  className='full-width'
                                  value={tag_arr ? tag_arr : ''}
                                  onChange={(event, value) => TagChange(event, value)}
                                  options={TagList ? TagList : []}
                                  getOptionLabel={(option) => option.name}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      onKeyDown={_handleKeyDown}
                                      label='Tags'
                                      variant='outlined'
                                    />
                                  )}
                                />
                                <div className='invalid-feedback'>{errors.tags}</div>
                                <input type='text' name='tags' value={tags} hidden />

                                {keyword_tag.map((row, i) => (
                                  <Chip
                                    key={i}
                                    label={row.name}
                                    deletevalue={i}
                                    onDelete={() => DeleteTag(i)}
                                  />
                                ))}
                              </Grid>
                              {/* tiles */}
                              <Grid item size={12}>
                                <Autocomplete
                                  multiple
                                  id='tiles_edit'
                                  className='full-width'
                                  value={tiles_tag ? tiles_tag : ''}
                                  onChange={(event, value) => TileChange(event, value)}
                                  options={TileList ? TileList : []}
                                  getOptionLabel={(option) => option.name}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      onKeyDown={_handleKeyDown}
                                      label='Tiles'
                                      variant='outlined'
                                    />
                                  )}
                                />
                                <div className='invalid-feedback'>{errors.tiles}</div>
                                <input type='text' name='tiles' value={tiles} hidden />
                              </Grid>

                              {visibilityPropertySelectEdit && (
                                <Grid item size={12}>
                                  <Autocomplete
                                    id='property'
                                    className='full-width'
                                    value={property_arr_set}
                                    onChange={PropertyChange}
                                    options={PropertyList ? PropertyList : []}
                                    onInputChange={(event, value, reason) => {
                                      if (reason == 'input') {
                                        PropertyListCall(value, 0);
                                      }
                                    }}
                                    getOptionLabel={(option) => option.full_name}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label='Right Holder/Partner'
                                        variant='outlined'
                                      />
                                    )}
                                  />
                                  <input
                                    type='text'
                                    name='properties_id'
                                    id='properties_id'
                                    value={properties_id}
                                    hidden
                                  />
                                  <div className='invalid-feedback'>{errors.properties_id}</div>
                                </Grid>
                              )}

                              {visibilityBrandSelectEdit && (
                                <Grid item size={12}>
                                  <Autocomplete
                                    id='brand'
                                    className='full-width'
                                    value={brand_arr_set}
                                    onChange={BrandListChange}
                                    options={BrandList ? BrandList : []}
                                    getOptionLabel={(option) => option.name}
                                    renderInput={(params) => (
                                      <TextField {...params} label='Brand' variant='outlined' />
                                    )}
                                  />
                                  <input
                                    type='text'
                                    name='brand_id'
                                    id='cbrand_id'
                                    value={comment_brand_id}
                                    hidden
                                  />
                                  <div className='invalid-feedback'>{errors.comment_brand_id}</div>
                                </Grid>
                              )}

                              <Grid item size={12}>
                                <input
                                  accept='image/*'
                                  name='media_images'
                                  className=''
                                  id='contained-button-file'
                                  onChange={(event) => handleCaptureMedia(event)}
                                  type='file'
                                />

                                <label htmlFor='contained-button-file'>
                                  <Button
                                    startIcon={<CloudUploadIcon color='secondary' />}
                                    variant='contained'
                                    component='span'
                                  >
                                    Upload
                                  </Button>
                                </label>

                                <Grid item size={12} className='flex margin_top2'>
                                  {media_upload_array.map((row, i) =>
                                    row.file_type == 'image' ? (
                                      <div key={i} className='relative_div comment_preview_img'>
                                        <img
                                          className='preview'
                                          style={{
                                            width: '100%',
                                            height: '50px',
                                            objectFit: 'fill',
                                          }}
                                          src={row.file_path}
                                          alt={row.file_s3_key}
                                          key={row.media_id}
                                          onError={(e) => {
                                            e.target.onerror = null;
                                            e.target.src = default_image;
                                          }}
                                        />
                                        <IconButton
                                          size='small'
                                          onClick={() => handleMediaDelete(i)}
                                          style={{
                                            position: 'absolute',
                                            right: '-10px',
                                            top: '-10px',
                                          }}
                                          color='secondary'
                                        >
                                          <ClearIcon color='secondary' />
                                        </IconButton>
                                      </div>
                                    ) : (
                                      <div key={i} className='relative_div comment_preview_img'>
                                        {row.name}
                                        <IconButton
                                          size='small'
                                          onClick={() => handleMediaDelete(i)}
                                          style={{
                                            position: 'absolute',
                                            right: '-10px',
                                            top: '-10px',
                                          }}
                                          color='secondary'
                                        >
                                          <ClearIcon color='secondary' />
                                        </IconButton>
                                      </div>
                                    ),
                                  )}
                                </Grid>
                              </Grid>

                              <Grid item size={12} className='text_right margin_top2'>
                                <Button
                                  color='secondary'
                                  onClick={() => visibilityEditCommentCancel(data.id)}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  variant='contained'
                                  disabled={submitted}
                                  onClick={() => handleUpdate(data.id)}
                                  type='button'
                                  color='secondary'
                                >
                                  {(submitted && 'Please Wait') || (!submitted && 'Update')}
                                </Button>
                              </Grid>
                            </Grid>
                          </ListItem>
                        </div>
                      </form>
                    </div>
                  </div>
                ))}
            </List>

            {visibilityCommentHistory && (
              <div className='text_right margin_top2'>
                <Button color='secondary' onClick={hideVisibilityCommentHistory}>
                  Back
                </Button>
              </div>
            )}

            {visibilityCommentHistory &&
              HistoryList.map((row, i) => (
                <div key={i} className='comment_card box_shadow nopadding relative_div'>
                  <ListItem alignItems='flex-start' style={{ flexWrap: 'wrap' }}>
                    <Grid container item spacing={1}>
                      <Grid item size={12}>
                        {row.msg}
                      </Grid>

                      {row.comment ? (
                        <Grid item size={12}>
                          {row.comment}
                        </Grid>
                      ) : (
                        ''
                      )}

                      {row.tags ? (
                        <Grid item size={12}>
                          {row.tags.map((tag_new_name, key) => (
                            <Chip key={key} label={tag_new_name} style={{ margin: '3px' }} />
                          ))}
                        </Grid>
                      ) : (
                        ''
                      )}

                      {row.property_name ? (
                        <Grid item size={12}>
                          <Chip label={row.property_name} style={{ margin: '3px' }} />
                        </Grid>
                      ) : (
                        ''
                      )}

                      {row.brand_name ? (
                        <Grid item size={12}>
                          <Chip label={row.brand_name} style={{ margin: '3px' }} />
                        </Grid>
                      ) : (
                        ''
                      )}

                      {row.tiles ? (
                        <Grid item size={12}>
                          {row.tiles.map((tiles_name, key) => (
                            <Chip key={key} label={tiles_name} style={{ margin: '3px' }} />
                          ))}
                        </Grid>
                      ) : (
                        ''
                      )}

                      {row.documents ? (
                        <Grid item size={12}>
                          {row.documents.map((data_get, key) => (
                            <div key={key} className='comment_share_section'>
                              <a
                                href={data_get.file_path}
                                style={{
                                  color: '#3678a8',
                                  textDecoration: 'underline',
                                  cursor: 'pointer',
                                }}
                              >
                                {data_get.name}
                              </a>
                            </div>
                          ))}
                        </Grid>
                      ) : (
                        ''
                      )}

                      <Grid item size={12}>
                        {row.date_time}
                      </Grid>
                    </Grid>
                  </ListItem>
                </div>
              ))}
          </Scrollbars>

          {visibilityAddComment && (
            <form
              id='addcomment'
              className='add_commant_form_dashboard'
              encType='multipart/form-data'
              autoComplete='off'
            >
              <div className='comment_card box_shadow nopadding relative_div'>
                <ListItem alignItems='flex-start' style={{ flexWrap: 'wrap' }}>
                  <Grid container item spacing={1}>
                    <Grid item size={12}>
                      <TextareaAutosize
                        style={{ width: '95%', background: 'transparent', marginTop: '0.5rem' }}
                        name='comments'
                        className='custom_textarea'
                        aria-label='minimum height'
                        minRows={2}
                        placeholder='Comments *'
                      />
                      <div className='invalid-feedback'>{errors.comments}</div>
                    </Grid>
                    <Grid item size={12}>
                      <Autocomplete
                        multiple
                        id='tags'
                        className='full-width'
                        onChange={(event, value) => TagChange(event, value)}
                        options={TagList ? TagList : []}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            onKeyDown={_handleKeyDown}
                            label='Tags'
                            variant='outlined'
                          />
                        )}
                      />
                      <div className='invalid-feedback'>{errors.tags}</div>
                      <input type='text' name='tags' value={tags} hidden />

                      {keyword_tag.map((row, i) => (
                        <Chip
                          key={i}
                          label={row.name}
                          deletevalue={i}
                          onDelete={() => DeleteTag(i)}
                        />
                      ))}
                    </Grid>

                    <Grid item size={12}>
                      <Autocomplete
                        multiple
                        id='tiles'
                        className='full-width'
                        onChange={(event, value) => TileChange(event, value)}
                        value={tiles_tag ? tiles_tag : ''}
                        options={TileList ? TileList : []}
                        getOptionLabel={(option) => option.name}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            onKeyDown={_handleKeyDown}
                            label='Tiles'
                            variant='outlined'
                          />
                        )}
                      />
                      <div className='invalid-feedback'>{errors.tiles}</div>
                      <input type='text' name='tiles' value={tiles} hidden />
                    </Grid>

                    {visibilityPropertySelect && (
                      <Grid item size={12}>
                        <Autocomplete
                          id='property'
                          className='full-width'
                          onChange={PropertyChange}
                          options={PropertyList ? PropertyList : []}
                          onInputChange={(event, value, reason) => {
                            if (reason == 'input') {
                              PropertyListCall(value);
                            }
                          }}
                          getOptionLabel={(option) => option.full_name}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label='Right Holder/Partner'
                              variant='outlined'
                            />
                          )}
                        />
                        <input
                          type='text'
                          name='properties_id'
                          id='properties_id'
                          value={properties_id}
                          hidden
                        />
                        <div className='invalid-feedback'>{errors.properties_id}</div>
                      </Grid>
                    )}

                    {visibilityBrandSelect && (
                      <Grid item size={12}>
                        <Autocomplete
                          id='brand'
                          className='full-width'
                          onChange={BrandListChange}
                          options={BrandList ? BrandList : []}
                          getOptionLabel={(option) => option.name}
                          renderInput={(params) => (
                            <TextField {...params} label='Brand' variant='outlined' />
                          )}
                        />
                        <input
                          type='text'
                          name='brand_id'
                          id='brand_id'
                          value={comment_brand_id}
                          hidden
                        />
                        <div className='invalid-feedback'>{errors.comment_brand_id}</div>
                      </Grid>
                    )}

                    <Grid item size={12}>
                      <input
                        accept='*'
                        name='media_images'
                        className=''
                        id='contained-button-file'
                        onChange={handleCaptureMedia}
                        type='file'
                      />

                      <label htmlFor='contained-button-file'>
                        <Button
                          startIcon={<CloudUploadIcon color='secondary' />}
                          variant='contained'
                          component='span'
                        >
                          Upload
                        </Button>
                      </label>

                      <Grid item size={12} className='flex margin_top2'>
                        {media_upload_array.map((row, i) =>
                          row.file_type == 'image' ? (
                            <div key={i} className='relative_div comment_preview_img'>
                              <img
                                className='preview'
                                style={{ width: '100%', height: '50px', objectFit: 'fill' }}
                                src={row.file_path}
                                alt={row.file_s3_key}
                                key={row.media_id}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = default_image;
                                }}
                              />
                              <IconButton
                                size='small'
                                onClick={() => handleMediaDelete(i)}
                                style={{ position: 'absolute', right: '-10px', top: '-10px' }}
                                color='secondary'
                              >
                                <ClearIcon color='secondary' />
                              </IconButton>
                            </div>
                          ) : (
                            <div key={i} className='relative_div comment_preview_img'>
                              {row.name}
                              <IconButton
                                size='small'
                                onClick={() => handleMediaDelete(i)}
                                style={{ position: 'absolute', right: '-10px', top: '-10px' }}
                                color='secondary'
                              >
                                <ClearIcon color='secondary' />
                              </IconButton>
                            </div>
                          ),
                        )}
                      </Grid>
                    </Grid>

                    <Grid item size={12} className='text_right margin_top2'>
                      <Button color='secondary' onClick={handleToggleVisibilityCancel}>
                        Cancel
                      </Button>
                      <Button
                        variant='contained'
                        disabled={submitted}
                        type='button'
                        onClick={handleSubmit}
                        color='secondary'
                      >
                        Save
                      </Button>
                    </Grid>
                  </Grid>
                </ListItem>
              </div>
            </form>
          )}

          {Boolean(ApiProvider.permission('comments_create')) && (
            <div>
              <Button
                variant='contained'
                color='secondary'
                onClick={handleToggleVisibilityAddComment}
              >
                Add Comment
              </Button>
            </div>
          )}
        </div>
      </Dialog>
    </div>
  );
}
